// 위임 폼의 체크박스 그룹마다 "전체 선택" 마스터 체크박스를 담당하는 Stimulus 컨트롤러.
// 역할: 그룹 내 아이템 체크박스를 마스터 체크박스로 일괄 토글하고, 아이템 상태를 마스터에 역동기화한다.
// CAUTION: 각 섹션이 독립 컨트롤러 인스턴스다. 마스터(all)와 아이템(item) 타깃은
//          반드시 같은 data-controller="select-all" 요소의 자손이어야 스코프가 맞는다.
import { Controller } from "@hotwired/stimulus"

// 그룹 내 아이템 체크박스를 마스터로 일괄 토글. 각 섹션이 독립 컨트롤러 인스턴스.
export default class extends Controller {
  static targets = ["all", "item"]

  // 마스터 클릭 → 그룹 전체를 마스터 상태로. 각 아이템에 change 이벤트를 dispatch 해
  // 문맥 노출(reveal) 패널이 전체선택에도 반응하게 한다.
  // CAUTION: 목표값(target)을 루프 전에 캡처한다. 아이템마다 dispatch 하는 change 가
  //   sync 를 즉시 호출해 마스터(all)를 indeterminate·false 로 흔드는데, 루프 안에서
  //   this.allTarget.checked 를 다시 읽으면 두 번째 아이템부터 흔들린 값(false)을 읽어
  //   "첫 항목 하나만 선택되는" 버그가 난다. target 지역변수로 불변 고정 후, 루프 끝에
  //   마스터 상태를 확정 복원한다.
  toggle() {
    const target = this.allTarget.checked
    this.itemTargets.forEach((cb) => {
      cb.checked = target
      cb.dispatchEvent(new Event("change", { bubbles: true }))
    })
    this.allTarget.checked = target
    this.allTarget.indeterminate = false
  }

  // 아이템 변경 → 마스터 상태 동기화(전부=checked, 일부=indeterminate).
  sync() {
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter((cb) => cb.checked).length
    this.allTarget.checked = checked === total && total > 0
    this.allTarget.indeterminate = checked > 0 && checked < total
  }
}
